import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f700ea86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline" }
const _hoisted_2 = {
  key: 0,
  class: "date"
}

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { onBeforeRouteLeave } from 'vue-router';
import { useInfo, useHome } from '@/store';
import { checkDirection } from '@/hooks/useCheck';
import { formatDate } from '@/hooks/useTransformTime';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { Thumbs, Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';

export default /*#__PURE__*/_defineComponent({
  __name: 'EventsTimeline',
  setup(__props) {

_useCssVars(_ctx => ({
  "19f2e7bf": (_unref(timeline).pc),
  "e338b724": (_unref(timeline).mobile),
  "e90dd74e": (_unref(timelineActive).pc),
  "416df408": (_unref(timelineActive).mobile),
  "4833f14e": (_unref(timelineActiveFirst).pc),
  "47ad31f0": (_unref(timelineActiveFirst).mobile),
  "e136b59a": (_unref(time).pc),
  "511187e2": (_unref(time).mobile),
  "5a3beacd": (_unref(timeActive).pc),
  "a58f1f08": (_unref(timeActive).mobile),
  "3e8f5f80": (_unref(timeNext).pc),
  "2b4ee46f": (_unref(timeNext).mobile),
  "8fd15586": (_unref(knife).pc),
  "fd0dba28": (_unref(knife).mobile),
  "0f28eb57": (_unref(knifeActive).pc),
  "2b3e1c06": (_unref(knifeActive).mobile)
}))

const { setThumbsSwiper } = useHome();
const { currentYearEvents, thumbsSwiper, activeIndex } = storeToRefs(useHome());
const breakpoints = {
  750: {
    slidesPerView: 4,
  },
};
const modules = [Thumbs, Navigation];
onBeforeRouteLeave(() => {
  thumbsSwiper.value?.destroy();
  setThumbsSwiper(null);
});
const { getImg } = useInfo();
const timeline = computed(() => ({
  pc: `url(${getImg('home_pc_timeline')})`,
  mobile: `url(${getImg('home_mobile_timeline')})`,
}));
const timelineActive = computed(() => ({
  pc: `url(${getImg('home_pc_timeline_active')})`,
  mobile: `url(${getImg('home_mobile_timeline_active')})`,
}));
const timelineActiveFirst = computed(() => ({
  pc: `url(${getImg('home_pc_timeline_active_first')})`,
  mobile: `url(${getImg('home_mobile_timeline_active_first')})`,
}));
const time = computed(() => ({
  pc: `url(${getImg('home_pc_time')})`,
  mobile: `url(${getImg('home_mobile_time')})`,
}));
const timeActive = computed(() => ({
  pc: `url(${getImg('home_pc_time_active')})`,
  mobile: `url(${getImg('home_mobile_time_active')})`,
}));
const timeNext = computed(() => ({
  pc: `url(${getImg('home_pc_time_next')})`,
  mobile: `url(${getImg('home_mobile_time_next')})`,
}));
const knife = computed(() => ({
  pc: `url(${getImg('home_pc_timeline_knife')})`,
  mobile: `url(${getImg('home_mobile_timeline_knife')})`,
}));
const knifeActive = computed(() => ({
  pc: `url(${getImg('home_pc_timeline_knife_active')})`,
  mobile: `url(${getImg('home_mobile_timeline_knife_active')})`,
}));

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(Swiper), {
      onSwiper: _unref(setThumbsSwiper),
      slidesPerView: 3,
      breakpoints: breakpoints,
      watchSlidesProgress: true,
      modules: modules,
      grabCursor: true,
      dir: _unref(checkDirection)
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentYearEvents), (date, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass([
            'time',
            {
              anniversary: date.isAnniversaryEvent,
              sibling: index === _unref(activeIndex) - 1 || index === _unref(activeIndex) + 1,
            },
          ])
              }, [
                (date.eventTime)
                  ? (_openBlock(), _createElementBlock("time", _hoisted_2, _toDisplayString(_unref(formatDate)(date.eventTime)), 1))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["onSwiper", "dir"])
  ], 512)), [
    [_vShow, _unref(currentYearEvents).length > 1]
  ])
}
}

})